module.exports = __webpack_public_path__ + "images/bora/city-default.png";